<recon-aggregator-ui [source]="source"></recon-aggregator-ui>
